/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "chat",
            "endpoint": "https://ts6nck4v0e.execute-api.us-east-2.amazonaws.com/demo",
            "region": "us-east-2"
        },
        {
            "name": "hidata",
            "endpoint": "https://zvntl9f0h9.execute-api.us-east-2.amazonaws.com/demo",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:0e0b5ba2-9141-4cff-9fb7-2ea73db81ec1",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_tptbi7YdI",
    "aws_user_pools_web_client_id": "20ho4nsd018pt67qib8oid7r8o",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "acquilingua-apk173646-demo",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
